import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=f06e6dc0&"
import script from "./ChannelList.vue?vue&type=script&lang=js&"
export * from "./ChannelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports